import apiClient from './client';
import type { InventoryRule, CreateInventoryRuleInput, CustomTargetingKey } from '@/types/inventory-rule';

// ========== INVENTORY RULES API ==========

// Interface para filtros de busca
export interface InventoryRulesFilters {
    search?: string;
    status?: string;
}

// Listar todas as regras de inventário (com filtros opcionais)
export const getInventoryRules = async (filters?: InventoryRulesFilters): Promise<InventoryRule[]> => {
    const params: Record<string, string> = {};
    
    if (filters?.search?.trim()) {
        params.search = filters.search.trim();
    }
    if (filters?.status) {
        params.status = filters.status;
    }

    const response = await apiClient.get<InventoryRule[]>('/inventory-rules', {
        params
    });
    return response.data;
};

// Obter regra de inventário por ID
export const getInventoryRuleById = async (ruleId: number): Promise<InventoryRule> => {
    const response = await apiClient.get<InventoryRule>(`/inventory-rules/${ruleId}`);
    return response.data;
};

// Criar nova regra de inventário
export const createInventoryRule = async (data: CreateInventoryRuleInput): Promise<InventoryRule> => {
    const response = await apiClient.post<InventoryRule>('/inventory-rules', data);
    return response.data;
};

// Listar custom targeting keys do GAM (retorna apenas os nomes)
export const getCustomKeysFromGAM = async (networkId: string): Promise<string[]> => {
    const response = await apiClient.get<CustomTargetingKey[]>('/inventory-rules/gam/keys', {
        params: { network_id: networkId }
    });
    // Retorna apenas os nomes das keys
    return response.data.map(key => key.name);
};

